import { api } from "./index";


export const toggleThreadLock = (contentID, type) =>
	api.patch(`/comments/${type}/${contentID}/lock`);
export const toggleCommentPin = (contentID, type) =>
	api.patch(`/comments/${type}/${contentID}/pin`);
export const getReplies = (contentID, type, query) =>
    api.get(`/comments/${type}/${contentID}/replies/get?${new URLSearchParams(query).toString()}`);
export const createReply = (contentID, type, replyData) =>
	api.post(`/comments/${type}/${contentID}/replies/create`, replyData);


// ! RESERVED ROUTES
// level comments
export const toggleCommentHighlight = (contentID, type) =>
	api.patch(`/comments/${type}/${contentID}/highlight`);